var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex px-2 -mx-2 cursor-pointer rounded-sm",
      class: { "font-medium": _vm.episode.active },
      style: _vm.style,
      attrs: {
        "data-test":
          "tab-playlist--entry" + (_vm.episode.active ? "--active" : "")
      },
      on: { mouseover: _vm.mouseOverHandler, mouseleave: _vm.mouseLeaveHandler }
    },
    [
      _vm.episode.active
        ? _c(
            "span",
            {
              staticClass: "w-8 py-2 mr-2 flex justify-center items-center",
              attrs: {
                "aria-hidden": "true",
                "data-test": "tab-playlist--entry--interaction"
              },
              on: {
                click: function($event) {
                  return _vm.play()
                }
              }
            },
            [
              _c("icon", {
                attrs: {
                  type: _vm.playing ? "menu-pause" : "menu-play",
                  size: 24
                }
              })
            ],
            1
          )
        : _c(
            "span",
            {
              staticClass: "w-8 py-2 mr-2 flex justify-center items-center",
              attrs: {
                "aria-hidden": "true",
                "data-test": "tab-playlist--entry--interaction"
              },
              on: {
                click: function($event) {
                  return _vm.select({ index: _vm.index, play: true })
                }
              }
            },
            [
              _vm.hover
                ? _c("icon", { attrs: { type: "menu-play", size: 24 } })
                : _c("icon", { attrs: { type: "menu-empty", size: 12 } })
            ],
            1
          ),
      _c(
        "span",
        {
          staticClass: "block w-full py-2 mr-2",
          attrs: { "data-test": "tab-playlist--entry--title" },
          on: {
            click: function($event) {
              return _vm.select({ index: _vm.index, play: true })
            }
          }
        },
        [_vm._v(_vm._s(_vm.episode.title))]
      ),
      _vm.episode.duration
        ? _c("timer", {
            staticClass: "block w-18 py-2",
            attrs: {
              time: _vm.episode.duration,
              "data-test": "tab-playlist--entry--timer"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }